import React from 'react';
import { LegalShell, Section, List } from '../../components/legal/LegalShell';

const CompliancePolicy = () => (
  <LegalShell eyebrow="Legal" title="Compliance Policy" updated="07 August 2026">
    <p>At Domestic Home Services Limited, we are committed to delivering a professional, transparent and customer-focused service. This Compliance Policy outlines the standards we follow when providing our home maintenance service plans and explains our commitment to ethical business practices, customer satisfaction and continuous improvement.</p>

    <Section n="1" title="Our Commitment">
      <p>We are committed to:</p>
      <List items={[
        'Treating every customer honestly, fairly and with respect.',
        'Providing clear, accurate and transparent information about our services.',
        'Ensuring customers fully understand the maintenance plans they purchase.',
        'Delivering a professional, efficient and responsive customer experience.',
        'Maintaining high standards of integrity in all of our business activities.',
        'Continually improving our services through customer feedback and regular internal reviews.',
      ]} />
    </Section>

    <Section n="2" title="Our Services">
      <p>Domestic Home Services Limited provides home maintenance service plans for residential properties throughout the United Kingdom.</p>
      <p>Depending on the plan selected, cover may include domestic appliances, boilers, plumbing and drainage services.</p>
      <p>Where repairs or maintenance are required, we arrange assistance through carefully selected independent third-party contractors. All repair work is carried out by those independent contractors in accordance with the terms of the customer's maintenance plan.</p>
    </Section>

    <Section n="3" title="Honest Sales & Customer Communication">
      <p>We believe customers should always receive clear and honest information before making a purchasing decision.</p>
      <p>We aim to ensure that:</p>
      <List items={[
        'Our sales process is transparent and straightforward.',
        'Customers receive accurate information about the benefits, limitations and terms of their chosen plan.',
        'Terms and Conditions are made available before a purchase is completed.',
        'Customers have the opportunity to ask questions before entering into an agreement.',
      ]} />
      <p>We never knowingly provide false, misleading or deceptive information.</p>
    </Section>

    <Section n="4" title="Customer Information & Privacy">
      <p>Protecting customer information is one of our highest priorities.</p>
      <p>We process personal information responsibly and in accordance with applicable UK data protection legislation.</p>
      <p>Customer information is collected and used only for legitimate business purposes, including:</p>
      <List items={[
        'Managing customer maintenance plans.',
        'Providing customer support.',
        'Processing payments.',
        'Arranging repair or maintenance services.',
        'Meeting our legal and regulatory obligations.',
      ]} />
      <p>We implement appropriate technical and organisational measures to safeguard personal information and do not sell customer personal data to third parties.</p>
    </Section>

    <Section n="5" title="Complaints Procedure">
      <p>We value customer feedback and take every complaint seriously.</p>
      <p>If you are dissatisfied with any aspect of our service, you can contact our Customer Support Team using the contact details available on our website or within your welcome documents.</p>
      <p>Upon receiving a complaint, we will:</p>
      <List items={[
        'Acknowledge your complaint promptly.',
        'Conduct a fair and impartial investigation.',
        'Keep you informed where appropriate throughout the process.',
        'Provide a clear written outcome once our investigation is complete.',
        'Take corrective action where improvements are identified.',
      ]} />
      <p>Our objective is to resolve complaints fairly, efficiently and as quickly as reasonably possible.</p>
    </Section>

    <Section n="6" title="Fraud Prevention">
      <p>To protect our customers and our business, we maintain appropriate procedures designed to help prevent fraud, identity theft and other unlawful activities.</p>
      <p>Where necessary, we may request additional information to verify a customer's identity or to help protect against fraudulent transactions or misuse of our services.</p>
    </Section>

    <Section n="7" title="Third-Party Contractors">
      <p>Domestic Home Services Limited works with independent third-party contractors to provide repair and maintenance services where required.</p>
      <p>We seek to work only with contractors who are suitably qualified, experienced and committed to delivering professional standards of workmanship and customer service.</p>
    </Section>

    <Section n="8" title="Continuous Improvement">
      <p>We regularly review our products, customer feedback and internal procedures to help improve the quality of our services.</p>
      <p>Customer comments, complaints and suggestions are valuable in helping us enhance the experience we provide.</p>
    </Section>

    <Section n="9" title="Contact Us">
      <p>If you have any questions regarding this Compliance Policy or wish to raise a concern, please contact us:</p>
      <p><b>Domestic Home Services Limited</b><br/>Email: hello@domestichomeservices.com<br/>Website: www.domestichomeservices.com</p>
      <p>Domestic Home Services Limited reviews this Compliance Policy periodically to ensure it remains accurate, up to date and reflects our commitment to providing professional, fair and transparent services to all customers.</p>
    </Section>
  </LegalShell>
);

export default CompliancePolicy;
